import { Component } from '@angular/core';
import { directus, Progetto } from '../../../../directus';
import { Router } from '@angular/router';
import { readItems } from "@directus/sdk";
import { CommonModule } from "@angular/common";
import { AuthService } from '../../services/auth.service';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BaseComponent } from '../base/base.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-progetti',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './progetti.component.html',
  styleUrl: './progetti.component.css'
})
export class ProgettiComponent extends BaseComponent {
  progetti: Progetto[] | undefined;

  constructor(protected override router: Router) {
    super(router);
    this.authService = inject(AuthService);
   }

  goToProgetto(id: number) {
    this.router.navigate(['/progetti', id]);
  }

  ngOnInit(): void {
    this.getAllProgetti();
  }

  async getAllProgetti() {
    try{
    //@ts-ignore
    this.progetti = await directus
      .request<Progetto[]>(readItems("progetti", {
        fields: ["id", "status", "nome", "descrizione", "website", "tipologia", "immagine", "colore"]
      }))
    } catch (error: any) {
      error = JSON.parse(JSON.stringify(error));
      if ( error && error != undefined ) {
        if (error.errors[0].extensions.code === 'FORBIDDEN') {
          this.logOut();
        }
      }
      //alert(error[0].extensions.code);
      console.error(error);

    }
  }

}
